import { UseStoreHooks } from '@/store/hook'

/**
 * 这个模块只暴露一个store
 * 在App.vue里面把store实例暴露出去并储存在这里
 * 由于vuex4 + vue3中，store实例不再绑定到Vue原型上，在setup以外（如request.ts中）我们想使用store需要费点功夫
*/
export class StoreUtils {
  static store: UseStoreHooks
}
